import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`inline-block overflow-hidden align-bottom ${className}`}>
      <motion.span
        className="inline-block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, ease, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeUp({ children, delay = 0, y = 24, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.85, ease, delay }}
    >
      {children}
    </motion.div>
  );
}

export function Chapter({ number, kicker, title, description, align = "left", className = "" }) {
  return (
    <div
      className={`relative flex flex-col gap-6 ${
        align === "center" ? "items-center text-center" : "items-start text-left"
      } ${className}`}
    >
      <FadeUp>
        <div className="flex items-center gap-4">
          <span className="font-mono-x text-xs tracking-[0.24em] text-white/40 uppercase">
            Chapter {number}
          </span>
          <span className="h-px w-16 bg-white/15" />
          <span className="font-mono-x text-xs tracking-[0.24em] text-white/60 uppercase">
            {kicker}
          </span>
        </div>
      </FadeUp>
      <FadeUp delay={0.1}>
        <h2 className="font-display text-[clamp(2.25rem,5vw,4.75rem)] leading-[0.98] tracking-[-0.03em] text-white max-w-4xl">
          {title}
        </h2>
      </FadeUp>
      {description && (
        <FadeUp delay={0.18}>
          <p className="max-w-2xl text-lg text-white/60 leading-relaxed">
            {description}
          </p>
        </FadeUp>
      )}
    </div>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`mx-auto w-full max-w-[1360px] px-6 md:px-10 ${className}`}>
      {children}
    </div>
  );
}

export function OverlineChip({ children, dot = true, className = "" }) {
  return (
    <span className={`chip ${className}`}>
      {dot && (
        <span className="relative flex h-1.5 w-1.5">
          <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-400" />
        </span>
      )}
      <span className="font-mono-x">{children}</span>
    </span>
  );
}
